import { createSlice } from "@reduxjs/toolkit";
import domainState from "../../../constants/domains/domainState";

// Create a Redux slice for the 'Domain' portion of the state
export const domainSlice = createSlice({
  name: "domain", // The name of the slice
  initialState: domainState, // Initial state for Domain
  reducers: {
    // Set domain data action
    setDomainData: (state, action) => {
      state.data = action.payload;
    },
    // Set domain host action
    setDomainHost: (state, action) => {
      state.data.host = action.payload;
    },
    // Set domain step action
    setDomainStep: (state, action) => {
      state.data.domainStep = action.payload;
    },
    // Set flag for Domain Drawer open/close action
    setIsDomainDrawerOpen: (state, action) => {
      state.data.isDomainDrawerOpen = action.payload;
    },
    // Set flag for Scripts Drawer open/close action
    setIsScriptsDrawerOpen: (state, action) => {
      state.data.isScriptsDrawerOpen = action.payload;
    },
    // Set domains action
    setDomains: (state, action) => {
      state.data.domains = action.payload;
    },
  },
});

// Destructure the action creators for easy access
export const {
  setDomainData,
  setDomainHost,
  setDomainStep,
  setIsDomainDrawerOpen,
  setIsScriptsDrawerOpen,
  setDomains,
} = domainSlice.actions;

// Export the reducer
export default domainSlice.reducer;
